import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Header from '../shared/components/Header/Header';
import Footer from '../shared/components/Footer/Footer';
import './WorldApp.css';

function WorldApp({ auth, fbApp }) {
  // Set body theme class for World
  useEffect(() => {
    document.body.classList.add('world-theme');
    document.body.classList.remove('mk8dx-theme');
    return () => {
      document.body.classList.remove('world-theme');
    };
  }, []);

  return (
    <div className="world-app">
      <Header currentGame="world" />
      <Outlet context={[auth, fbApp]} />
      <Footer />
    </div>
  );
}

export default WorldApp;
